// DS: i3.2
import React from 'react';
import IconWrap from '../../IconWrap';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
const TrophyPurpleGradient = (props)=>{
    const gradientIdPrefix = useUniqueId();
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21.0874 28C21.3707 28 21.6004 27.7687 21.6004 27.4833V26.6226C21.6004 26.1945 19.8449 24.5558 19.4283 24.5557C18.5449 24.5556 17.8288 23.8395 17.8288 22.9561V21.7878C17.8288 20.7543 18.4046 19.8069 19.322 19.3309L22.7 17.5782C22.7283 17.5635 22.7467 17.535 22.7486 17.5033L23.4695 5.05695C23.5027 4.48358 23.048 4.00019 22.4737 4.00004C20.9819 3.99965 18.6125 4.00207 16.4529 4.01324C13.9847 4.00195 11.2947 3.9996 9.69239 4.00005C9.11806 4.00022 8.66272 4.48358 8.69593 5.05695L9.41687 17.5033C9.41871 17.535 9.43716 17.5635 9.46543 17.5782L12.8434 19.3309C13.7608 19.8069 14.3366 20.7543 14.3366 21.7878V22.9561C14.3366 23.8395 13.6205 24.5556 12.7372 24.5557C12.3206 24.5558 10.5651 26.1945 10.5651 26.6226V27.4833C10.5651 27.7687 10.7947 28 11.078 28H21.0874Z",
        fill: `url(#${gradientIdPrefix}-0)`
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M29.901 7.9917C29.9068 7.9917 29.9118 7.9877 29.9131 7.98207L30.3591 6.02636C30.3622 6.01286 30.3519 5.99999 30.3381 5.99999L29.7621 5.99999C27.2582 5.99999 25.1798 7.93483 25.001 10.4324L24.8705 12.2552C24.7431 14.0337 26.1516 15.5466 27.9346 15.5466C27.9402 15.5466 27.9451 15.5428 27.9465 15.5374L28.4752 13.5003C28.4764 13.496 28.473 13.4917 28.4685 13.4917L27.4818 13.4917C26.9433 13.4917 26.5311 13.0123 26.6117 12.4799C26.6769 12.0497 27.0467 11.7317 27.4818 11.7317H28.9946C28.9995 11.7317 29.0038 11.7282 29.0049 11.7234L29.4866 9.50133C29.4877 9.49638 29.4839 9.49171 29.4789 9.49171L27.9749 9.49171C27.5021 9.49171 27.1473 9.05969 27.2391 8.59598C27.3087 8.24477 27.6168 7.9917 27.9749 7.9917L29.901 7.9917Z",
        fill: `url(#${gradientIdPrefix}-1)`
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2.09901 7.9917C2.09324 7.9917 2.08823 7.9877 2.08694 7.98207L1.64091 6.02636C1.63783 6.01286 1.64809 5.99999 1.66194 5.99999L2.2379 5.99999C4.74184 5.99999 6.82018 7.93483 6.99902 10.4324L7.12955 12.2552C7.2569 14.0337 5.84843 15.5466 4.06542 15.5466C4.05982 15.5466 4.05493 15.5428 4.05353 15.5374L3.52478 13.5003C3.52365 13.496 3.52695 13.4917 3.53148 13.4917L4.5182 13.4917C5.05672 13.4917 5.46893 13.0123 5.38826 12.4799C5.32308 12.0497 4.9533 11.7317 4.5182 11.7317H3.00545C3.00048 11.7317 2.99618 11.7282 2.99513 11.7234L2.51339 9.50133C2.51231 9.49638 2.51608 9.49171 2.52115 9.49171L4.02514 9.49171C4.49786 9.49171 4.8527 9.05969 4.76085 8.59598C4.69129 8.24477 4.38318 7.9917 4.02514 7.9917L2.09901 7.9917Z",
        fill: `url(#${gradientIdPrefix}-2)`
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: `${gradientIdPrefix}-0`,
        x1: 23.5307,
        y1: 16,
        x2: 8.63477,
        y2: 16,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#7174F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#853FB0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: `${gradientIdPrefix}-1`,
        x1: 30.3651,
        y1: 10.7733,
        x2: 24.6348,
        y2: 10.7733,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#7174F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#853FB0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: `${gradientIdPrefix}-2`,
        x1: 1.6349,
        y1: 10.7733,
        x2: 7.36523,
        y2: 10.7733,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#7174F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#853FB0"
    })))));
};
TrophyPurpleGradient.displayName = 'Add';
export default TrophyPurpleGradient;

//# sourceMappingURL=TrophyPurpleGradient.js.map